
import React, {FC, MouseEvent, useState, useRef, useEffect, ChangeEvent, MutableRefObject}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';
import { SnackbarAction, SnackbarKey, useSnackbar } from 'notistack';

import { debounce, sum } from 'lodash';

import { addMinutes } from 'date-fns';

import { Control, Controller, FieldArray, FieldArrayMethodProps, FormProvider, useFieldArray, useForm, UseFormGetValues, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { StringIfPlural, useTranslation  } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import CopyAllIcon from '@mui/icons-material/CopyAll';

import CheckIcon from '@mui/icons-material/Check';

import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import QueueIcon from '@mui/icons-material/Queue';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';


import AssignmentIcon from '@mui/icons-material/Assignment';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import SchoolIcon from '@mui/icons-material/School';
import DescriptionIcon from '@mui/icons-material/Description';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import ArchiveIcon from '@mui/icons-material/Archive';

import FastfoodIcon from '@mui/icons-material/Fastfood';

import { MdOutlineAdd, MdOutlineCancel, MdOutlineCheckCircle } from 'react-icons/md';


import entityService, { useBasicFilterEntity } from 'features/services/Entity';
import { currentBasicTextFilterPropsAtom, currentFormNameAtom,currentUserSessionAtom, 
      isSearchBoxShowAtom, isSaveLoadingAtom, isWaitingBoxShowAtom } from 'library/store';
import useBillingService, { useBasicFilterBilling } from './services/Billing';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { defaultFeatureDescription, IEntity, IFeatureDescription, IFeatureParameter, IResult } from 'library/interface';
import Button from '@mui/material/Button';
import { Checkbox, FormControlLabel, IconButton, InputAdornment, MenuItem, Tabs, Tab, Typography, Link, FormHelperText } from '@mui/material';
import NumberFormat, { NumberFormatValues } from 'react-number-format';

import { IBilling, IBillingDelivery, IBillingDeliveryDetail, IBillingDetail, IBillingDetailInfo, 
        IBillingInfo, IBillingPackagingDetail, IBillingRentalResource, IBillingServiceTask, ICommissionDistribution, 
        defaultBilling, defaultBillingDelivery, defaultBillingDetail } from './models/Billing';


import TextFieldRight from 'components/ui/TextFieldRight';
import { FormDialog } from 'components/ui/FormDialog';
import { BasicTextFilterForm } from 'components/ui/BasicTextFilterForm';
import useEnumerationService, { useBasicFilterEnumeration, useEnumerationItemCreateUpdate } from 'features/configuration/services/Enumeration';


import IEnumeration,  { IEnumerationItem, Enum_SERVICE_TASK, 
  Enum_ARTICLE_OPTION, Enum_PRICE_PURPOSE, 
  Enum_MAINTENANCE_CATEGORY, Enum_CONTRACT_SCOPE, Enum_CONTRACT_TYPE,  
  Enum_RENTAL_PERIODICITY,
  
  Enum_CONSUMPTION_OPTION,
  
  defaultEnumerationItem,
  Enum_INSURANCE} from 'features/configuration/models/Enumeration';

import useProductService, { useBasicFilterProduct, useBasicFilterProductWithOptions } from 'features/setup/services/Product';

import usePersonService, {useBasicFilterPerson, useBasicFilterPersonSearch}  from 'features/production/services/Person';

import { IProduct, IProductOption } from 'features/setup/models/Product';

import { carouselImage, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import EntityExpression from 'components/ui/EntityExpression';
import { isFalsy } from 'utility-types';
import ArrayFieldTableEx, { ActionIconTableRow, HeadCell } from 'components/ui/ArrayFieldTableEx';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { IPerson, PersonType, defaultPerson } from 'features/production/models/Person';

import useUtils from 'library/utils';

import { useBasicFilterEmployee } from 'features/setup/services/Employee';
import { IEmployee } from 'features/setup/models/Employee';
import { IPackaging } from 'features/setup/models/Packaging';
import { useBasicFilterPackaging } from 'features/setup/services/Packaging';
import { GrClose, GrSearch } from 'react-icons/gr';
import EnhancedTable from 'components/ui/EnhancedTable';
import { NestCamWiredStandTwoTone } from '@mui/icons-material';
import ArrayField from 'components/ui/ArrayField';
import { title } from 'process';
import { DialogEnumerationItemForm } from 'features/configuration/DialogEnumerationItemForm';
import { defaultStore } from 'features/configuration';
import { IStore } from 'features/configuration/models/Store';
import TextFieldCenter from 'components/ui/TextFieldCenter';



export interface BasicBillingDetailFormProps {
    
  control: Control<IBilling>,
  
  getValues: UseFormGetValues<IBilling>,
  setValue: UseFormSetValue<IBilling>,
  watch: UseFormWatch<IBilling>,
}

//type HasPersonPath<O extends FieldValues> = O extends { personPath: IPerson } ? BasicPersonFormProps<O> : never;




export function BasicBillingDetailForm 
({ setValue ,getValues, watch, control}: BasicBillingDetailFormProps) {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();  
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  
    const {id} = useParams();
  
    const {range, addDurationInPeriod} = useUtils();
  
    const {language: lg, taskCodes, userDescription, userName, 
        employeeId, roleEntities, applicationSetup, userStores} = useRecoilValue(currentUserSessionAtom);
    
    const [isWaitingBoxShow, setIsWaitingBoxShow] = useRecoilState(isWaitingBoxShowAtom);
  
    const [_id, _setId] = useState<number>( Number( id || 0 ) );
  
    const {retrieveEntity, retrieveData, openEntityActionDrawer, executeEntityFeature,
        checkEntityExpressionSyntax, checkEntitySaveAuthorization, openEntityPrintDrawer } = entityService();
  
      
    const { getProductOptionsByBilling } = useProductService();
  
    const { createBilling, updateBilling, evaluateAddedProduct, getCommissionDistributionsByBilling, deliverBillingDetail,
            createBillingDelivery, updateBillingDelivery, getBillingDeliveriesByBilling } = useBillingService();

  const {getEnumerationItemsByEnumerationCodes,getExtensionEnumerationItemsByProduct, getAsOptions } = useEnumerationService();
  
  const { createPerson, updatePerson, 
      getPersonsSearchCount, 
      getBirthDateType, getDateFormat, getDayFormat } = usePersonService();

  
  const [currentFormName, setCurrentFormNameAtom] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

  const watchBillingDetailIndex = watch('currentBillingDetailIndex');
  const watchBusinessEmployeeId = watch('businessEmployeeId');  
      
  const [openEntityFilter, setOpenEntityFilter] = useState(false);
  const basicFilterEntity = useBasicFilterEntity( 
      (event: React.MouseEvent<unknown>, row: IEntity) => {
          const {name, description} = row;

          // setValue('entityName', name || '');
          // setValue('entityDescription', description || '');
                           
          setOpenEntityFilter(false);
      }
  );

  const [openEnumerationFilter, setOpenEnumerationFilter] = useState(false);
  const basicFilterEnumeration = useBasicFilterEnumeration( 
      (event: React.MouseEvent<unknown>, row: IEnumeration) => {
          const {id, name, description} = row;

          // setValue('enumerationId', id);
          // setValue('enumerationName', name);
                           
          setOpenEnumerationFilter(false);
      }
  );

  

  const refFirstName = useRef<string>('');
  const refLastName = useRef<string>('');
  const refParticularSign = useRef<string>('');
  const refId = useRef<number>(getValues().id);
  
  
  const emptyFunc = (obj: any) => {}
  
  // const methods = useForm<IPerson>({defaultValues:defaultPerson});
  // const { register, setValue ,getValues, watch, reset ,handleSubmit ,control , formState: { errors } } = methods;

    
  type SearchPersonUsage = 'person' | 'father' | 'mother' | 'tutor';
  const [currentSearchPersonUsage, setCurrentSearchPersonUsage] = useState<SearchPersonUsage>('person');

  const [openPersonSearchFilter, setOpenPersonSearchFilter] = useState(false);
  const basicFilterPersonSearch = useBasicFilterPersonSearch( 
      () => {
        // const { firstName, lastName, particularSign,
        //         fatherFirstName, fatherLastName, fatherParticularSign,
        //         motherFirstName, motherLastName, motherParticularSign,
        //         tutorFirstName, tutorLastName, tutorParticularSign} = getValues();

        // const _firstName = (currentSearchPersonUsage === 'father') ? fatherFirstName :
        //             (currentSearchPersonUsage === 'mother') ? motherFirstName :
        //               (currentSearchPersonUsage === 'tutor') ? tutorFirstName : firstName;
        // const _lastName = (currentSearchPersonUsage === 'father') ? fatherLastName :
        //             (currentSearchPersonUsage === 'mother') ? motherLastName :
        //               (currentSearchPersonUsage === 'tutor') ? tutorLastName : lastName;
        // const _particularSign = (currentSearchPersonUsage === 'father') ? fatherParticularSign :
        //               (currentSearchPersonUsage === 'mother') ? motherParticularSign :
        //                 (currentSearchPersonUsage === 'tutor') ? tutorParticularSign : particularSign;

        return {firstName: refFirstName.current, lastName: refLastName.current, particularSign: refParticularSign.current};
        //return refPersonSearch.current || {firstName: '', lastName: '', particularSign: ''};
      },      
      (event: React.MouseEvent<unknown>, row: IPerson) => {
          const {id, firstName, lastName, birthDate, birthPlace, particularSign, email1, email2, corporationName, corporationType, creationDate,
              portable1, portable2, country, town, addressLine1, addressLine2} = row;
                               
        setOpenPersonSearchFilter(false);
      }
  );

  const {canAddEnumerationItem, canUpdateEnumerationItem, displayEnumerationItemDialog,
      enumerationItem, hideEnumerationItemDialog, saveEnumerationItem,
      onAddItemClick, onUpdateItemClick } = useEnumerationItemCreateUpdate();

  const [openPersonFilter, setOpenPersonFilter] = useState(false);
  const basicFilterPerson = useBasicFilterPerson( 
      (event: React.MouseEvent<unknown>, row: IPerson) => {
          const {id, type, firstName, lastName, birthDate, birthPlace, 
            particularSign, corporationName, corporationType, creationDate,
            portable1, portable2, email1, email2, country, town, addressLine1, addressLine2} = row;
                
           
        
       
        setOpenPersonFilter(false);
      }
  );


  const [openEmployeeFilter, setOpenEmployeeFilter] = useState(false);
    const basicFilterEmployee = useBasicFilterEmployee( 
        (event: React.MouseEvent<unknown>, row: IEmployee) => {
          const {id, firstName, lastName, managerFirstName, managerLastName, employeeTasks, } = row;        
          
            
          const billingDetail = getValues().billingDetails.at(watchBillingDetailIndex);        
          if(isFalsy(billingDetail)) return;
              
                  
          if(currentEmployeeUsage === 'billing-detail-service') {
            const billingServiceTask = billingDetail.billingServiceTasks.at(billingServiceTaskIndex);
            if(isFalsy(billingServiceTask)) return;
            
            if(!employeeTasks.some(t => t.taskCode === billingServiceTask.taskCode)) {
              enqueueSnackbar( t('This service or package can not be assign to this employee'), { variant: 'warning',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
              return;
            } 
            
            (refUpdateBillingServiceTask.current??emptyFunc)(billingServiceTaskIndex, {...billingServiceTask!, 
              employeeId: id, employeeFullName: `${lastName} ${firstName}`.trim() }); 
            
          } else if(currentEmployeeUsage === 'billing-packaging-service') {
                                
            const billingPackagingDetail = billingDetail.billingPackagingDetails.at(billingPackagingServiceIndex);
            if(isFalsy(billingPackagingDetail)) return;
  
            const billingServiceTask = billingPackagingDetail.billingServiceTasks.at(billingPackagingServiceTaskIndex);
            if(isFalsy(billingServiceTask)) return;
  
            if(!employeeTasks.some(t => t.taskCode === billingServiceTask.taskCode)) {
              enqueueSnackbar( t('This service or package can not be assign to this employee'), { variant: 'warning',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
              return;
            }
  
            (refUpdateBillingPackagingServiceTask.current??emptyFunc)(billingPackagingServiceTaskIndex, {...billingServiceTask!, 
              employeeId: id, employeeFullName: `${lastName} ${firstName}`.trim() }); 
          } else if(currentEmployeeUsage === 'billing-service') { 
            if(billingDetail.type === 'service') {
              for(var i=0; i<billingDetail.billingServiceTasks.length; i++ ){  
                const billingServiceTask = billingDetail.billingServiceTasks[i];
                if(billingServiceTask.employeeId <=0 && employeeTasks.some( t => t.taskCode === billingServiceTask.taskCode ) ) {
                      
                      setValue(`billingDetails.${watchBillingDetailIndex}.billingServiceTasks.${i}.employeeId`, id);
                      setValue(`billingDetails.${watchBillingDetailIndex}.billingServiceTasks.${i}.employeeFullName`, `${lastName} ${firstName}`.trim() );
                  } 
              }            
            } else if(billingDetail.type === 'packaging') {
              for(var k=0; k< billingDetail.billingPackagingDetails.length; k++) {
                const billingPackagingDetail = billingDetail.billingPackagingDetails[k];
                for(var i=0; i< billingPackagingDetail.billingServiceTasks.length; i++) {
                  const billingServiceTask = billingPackagingDetail.billingServiceTasks[i];
                  if(billingServiceTask.employeeId <=0 && employeeTasks.some( t => t.taskCode === billingServiceTask.taskCode ) ) {
                      
                    setValue(`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${k}.billingServiceTasks.${i}.employeeId`, id);
                    setValue(`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${k}.billingServiceTasks.${i}.employeeFullName`, `${lastName} ${firstName}`.trim() );
                  }
                }
              }
            }
          }
  
  
          // (refUpdateBillingDetail.current??emptyFunc)(watchBillingDetailIndex, 
          //     {...service, employeeId: id, employeeFirstName: firstName, employeeLastName: lastName,
          //       employeeFullName: `${lg.includes('fr')? lastName:firstName} ${lg.includes('fr')? firstName:lastName}`.trim() });  
  
          setOpenEmployeeFilter(false);
        }
    );


  const { mutate: mutateDeliverBillingDetail } = useMutation<IResult<IBillingDetail>,Error, {id: number, deliveryDate: Date, isDelivered: boolean, isDeliveryDateDefine: boolean } >(
        deliverBillingDetail , {   
        onSuccess: (data: IResult<IBillingDetail>) => {
            enqueueSnackbar( t('_Operation_done'), { variant: 'success',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
                        
            const index = getValues().billingDetails.findIndex(b => b.id === data.data.id);
            if(index >= 0) {
            const billingDetail = getValues().billingDetails[index];

            // (refUpdateBillingDetail.current??emptyFunc)(index, {...billingDetail, 
            //         isDelivered: data.data.isDelivered, isDeliveryDateDefine: data.data.isDeliveryDateDefine , 
            //         deliveryDate: data.data.deliveryDate} as unknown as IBillingDetail);
            }
            
            setOpenBillingDetailServiceDelivery(false);
        },
        onError: (err: Error) => {          
            enqueueSnackbar( err?.message, { variant: 'error',
            anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
            setOpenBillingDetailServiceDelivery(false);      
        }
        });

    const {data: enumItems, refetch: refetchEnumerationItems} = useQuery<IEnumerationItem[]>( ['EnumerationItems', 'BillingDetail'], () => getEnumerationItemsByEnumerationCodes
        ( [ 
          Enum_SERVICE_TASK, 
          Enum_ARTICLE_OPTION, Enum_CONSUMPTION_OPTION,
          Enum_MAINTENANCE_CATEGORY, Enum_CONTRACT_SCOPE, Enum_CONTRACT_TYPE, Enum_RENTAL_PERIODICITY,
            Enum_PRICE_PURPOSE, Enum_INSURANCE ] ));
    
    // const {data: enumItems2} = useQuery<IEnumerationItem[]>( ['EnumerationItems2', 'BillingDetail'], () => getEnumerationItemsByEnumerationCodes
    //     ( [Enum_SERVICE_TASK, 
    //         Enum_ARTICLE_OPTION, Enum_CONSUMPTION_OPTION,
    //         Enum_MAINTENANCE_CATEGORY, Enum_CONTRACT_SCOPE, Enum_CONTRACT_TYPE, Enum_RENTAL_PERIODICITY  ] ));


  const checkAllowedDiscount = (billingDetail: IBillingDetail, valueAmount: number) => {
        const {type, maxDiscountAmount, loaded, baseAmount, unityAmount} = billingDetail;      

        console.log(billingDetail);
        
        if( (valueAmount<0) || (valueAmount>0 && loaded>0) ) {
          enqueueSnackbar( `${t('Invalid amount')} ${valueAmount} : [0-${maxDiscountAmount}]` ,
              { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          return false;
        }
  
        if( valueAmount > 0 && maxDiscountAmount<valueAmount) {
          enqueueSnackbar( `${t('The maximum discount amount is')} : ${maxDiscountAmount}` ,
              { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          return false;
        }
  
        if(['article','packaging','consumption', 'rental'].includes(type) && valueAmount > unityAmount){
          enqueueSnackbar( `${t('The maximum discount amount is')} : ${unityAmount}` ,
              { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          return false;
        }
  
        if( !['article','packaging','consumption', 'rental'].includes(type) && valueAmount > baseAmount){
          enqueueSnackbar( `${t('The maximum discount amount is')} : ${baseAmount}` ,
              { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          return false;
        }
  
        //debouncedAmount();
        return true;
      }

      const checkAllowedLoaded = (billingDetail: IBillingDetail, valueAmount: number) => {
            const {maxLoadedAmount, discount} = billingDetail;      
            console.log(billingDetail);
            console.log(valueAmount);
      
            if((valueAmount<0) || (valueAmount>0 && discount > 0) ) {
              enqueueSnackbar( `${t('Invalid amount')} : [0-${maxLoadedAmount}]` ,
                 { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
              return false;
            }
      
            if( valueAmount > 0 && maxLoadedAmount<valueAmount) {
              enqueueSnackbar( `${t('The maximum loaded amount is')} : ${maxLoadedAmount}` ,
                 { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
              return false;
            }
      
            //debouncedAmount();
            return true;
          }

      const checkAllowedDiscountOrLoaded = (billingDetail: IBillingDetail, valueAmount: number) => {
        const {maxLoadedAmount, maxDiscountAmount, unityAmount, baseAmount, loaded, } = billingDetail;      
  
        if((valueAmount<0) ) {
          enqueueSnackbar( `${t('Invalid amount')} : [${unityAmount-maxDiscountAmount}-${unityAmount}],  [${unityAmount}-${unityAmount+maxLoadedAmount}]` ,
             { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          return false;
        }
  
        if( valueAmount > 0 && maxLoadedAmount+unityAmount>valueAmount) {
          enqueueSnackbar( `${t('The maximum loaded amount is')} : ${maxLoadedAmount}` ,
             { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          return false;
        }

        if( valueAmount > 0 && unityAmount-maxDiscountAmount<valueAmount) {
          enqueueSnackbar( `${t('The maximum discount amount is')} : ${maxDiscountAmount}` ,
              { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          return false;
        }
  
        //debouncedAmount();
        return true;
      }

    const handleQuantityIncDec = (index: number,value: number) => {
      const qty = getValues().billingDetails[index].quantity;
      if(value<0 && qty >= 1 )
        setValue(`billingDetails.${index}.quantity` as any, qty - 1);
      else if(value>0)
        setValue(`billingDetails.${index}.quantity` as any, qty + 1);
    }
        

    type PersonUsage = 'customer' | 'billing-detail-service' | 'billing-packaging-service' | 'billing-detail-formation' | 'billing-detail-exam';
            
    const [currentPersonUsage, setCurrentPersonUsage] = useState<PersonUsage>('customer');
    const handleClickOpenPerson = async (event: any, usage: PersonUsage) => {
        setCurrentPersonUsage(usage);
        setOpenPersonFilter(true);
    }
            
    const handleClickRemovePerson = async (event: any, usage: PersonUsage) => {

        if( ['billing-detail-service', 'billing-detail-formation', 'billing-detail-exam'].includes(usage) ) {

        const billingDetail = getValues().billingDetails.at(watchBillingDetailIndex);
        if(isFalsy(billingDetail)) return;

        setValue(`billingDetails.${watchBillingDetailIndex}`, {...billingDetail!, 
            personId: -1, studentId: -1, patientId: -1 , firstName: '', lastName: '', portable1: '', 
            portable2: '', email1: '', email2: '' } as unknown as IBillingDetail); 
        // (refUpdateBillingDetail.current??emptyFunc)(watchBillingDetailIndex, {...billingDetail!, 
        //     personId: -1, studentId: -1 , firstName: '', lastName: '', portable1: '', 
        //     portable2: '', email1: '', email2: '' } as unknown as IBillingDetail); 

        } else if(usage === 'billing-packaging-service') {
        const billingDetail = getValues().billingDetails.at(watchBillingDetailIndex);
        if(isFalsy(billingDetail)) return;
        
        const billingPackagingDetail = billingDetail.billingPackagingDetails.at(billingPackagingServiceIndex);
        if(isFalsy(billingPackagingDetail)) return;

        (refUpdateBillingPackagingDetail.current??emptyFunc)(billingPackagingServiceIndex, {...billingPackagingDetail!, 
            personId: -1, firstName: '', lastName: '', portable1: '', portable2: '', email1: '', email2: '' }); 
        }      
    }

    const [personsCopy, setPersonsCopy] = useState<IPerson[]>([]);
        const [openPersonCopy, setOpenPersonCopy] = useState<boolean>(false);
        const handleClickOpenPersonCopy = async (event: any, usage: PersonUsage) => {
          setCurrentPersonUsage(usage);
    
          var persons : IPerson[] = [];
          getValues().billingDetails.forEach( billingDetail => {
              if( ['service', 'formation', 'exam'].includes(billingDetail.type) && billingDetail.personId <= 0 && 
                    isFalsy(persons.find( p => p.firstName === billingDetail.firstName && p.lastName === billingDetail.lastName ) ) )
                persons.push( {...defaultPerson, id: -persons.length, firstName: billingDetail.firstName, lastName: billingDetail.lastName} );
              else if(billingDetail.type === 'packaging') {
                billingDetail.billingPackagingDetails.forEach( billingPackagingDetail => {
                  if(billingPackagingDetail.type === 'service' && billingPackagingDetail.personId <= 0 && 
                      isFalsy(persons.find( p => p.firstName === billingPackagingDetail.firstName && p.lastName === billingPackagingDetail.lastName ) ) )
                    persons.push( {...defaultPerson, id: -persons.length, firstName: billingPackagingDetail.firstName, lastName: billingPackagingDetail.lastName} );
                })
              }
            });
    
          setPersonsCopy(persons);
          setOpenPersonCopy(true);
        }

    const [openBillingDetailInfo, setOpenBillingDetailInfo] = useState<boolean>(false);
        const handleLinkClickBillingDetailInfo = (event: any) => {
            setOpenBillingDetailInfo(true);
        }


    const cellEditableBillingDetailInfo = (row: IBillingDetailInfo, cellId: keyof IBillingDetailInfo) => { 
        return true;
    }

    const [headBillingDetailInfoCells, setHeadBillingDetailInfoCells]  = useState<HeadCell<IBillingDetailInfo>[]>([]);
    useEffect(() => {
      setHeadBillingDetailInfoCells([   
        {id:'description', label : t('Description'),  display: true, type: 'string', width: 60, isEditable: cellEditableBillingDetailInfo},   
        {id:'designation', label : t('Designation'),  display: true, type: 'string', width: 40, isEditable: cellEditableBillingDetailInfo}, 
      ]);
    }, [t,i18n]);
        

    const refAppendBillingDetailInfos = useRef<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>(null);
    const refUpdateBillingDetailInfo = useRef<(index: number,value: Partial<FieldArray<IBilling>> ) => void>(null);
    const refRemoveBillingDetailInfo = useRef<(index: number ) => void>(null);
     
    const billingDetailInfoRowActionIcon = ( row: IBillingDetailInfo) : ActionIconTableRow<IBilling,IBillingDetailInfo> => {
          
      const res: ActionIconTableRow<IBilling,IBillingDetailInfo> = {
        toolTip: 'viewDetails',
        icon: RemoveCircleIcon,
        hasAction: (getValues().status === '95'),  // ((optionPropertyName1 || '') !== '') || ((optionPropertyName2 || '') !== '') || ((optionPropertyName3 || '') !== ''),
        isActionExecuting: true,
        onRowClickIcon: (event : any,index: number, row: IBillingDetailInfo) => {          
          (refRemoveBillingDetailInfo.current??emptyFunc)(index);                        
        }
      }
      return res;
  }

  const handleAddBillingDetailInfos = (event: any) => {      
        const billingDetail = getValues().billingDetails.at(watchBillingDetailIndex);
        if(isFalsy(billingDetail)) return;
  
        if(billingDetail.billingDetailInfos.some( x => isFalsy(x.description) && isFalsy(x.designation))) return;
  
        (refAppendBillingDetailInfos.current??emptyFunc)({id: 0, billingDetailId: billingDetail.id, description: '', designation: '' });   
      }

    const  [openBillingDetailServiceDelivery, setOpenBillingDetailServiceDelivery] = useState<boolean>(false);
        
    const handleOkBillingDetailServiceDelivery = async () => {
  
      if(watchBillingDetailIndex < 0 || watchBillingDetailIndex >= getValues().billingDetails.length ) return;
  
      const billingDetail = getValues().billingDetails.at(watchBillingDetailIndex);
      if(isFalsy(billingDetail)) return;
  
      const {id, deliveryDate, isDelivered, isDeliveryDateDefine} = billingDetail;
      mutateDeliverBillingDetail({id, deliveryDate, isDelivered, isDeliveryDateDefine});
    }
  
  
    const [billingServiceTaskIndex, setBillingServiceTaskIndex] = useState<number>(-1);
  
    const getInputAdornmentServiceTaskEmployee = (row: IBillingServiceTask, cellId: keyof IBillingServiceTask)  => ({
    
      toolTip: 'Employee',
      icon: ArrowDropDownCircleIcon,
      //iconDisable: row.resourceId > 0,
      onClickIcon: (event: any, index: number, row: IBillingServiceTask ) => {
  
        setCurrentEmployeeUsage('billing-detail-service');
        setBillingServiceTaskIndex(index);
        setOpenEmployeeFilter(true);
      }  
    })
  
    const getServiceTaskCode = (row: IBillingServiceTask, cellId: keyof IBillingServiceTask, 
      opts: {value: string|number, name: string}[]) => {        
      
        return getAsOptions(refEnumItems.current ?? [],Enum_SERVICE_TASK);
    }
  
    const [headBillingServiceTaskCells, setHeadBillingServiceTaskCells]  = useState<HeadCell<IBillingServiceTask>[]>([   
      {id:'taskCode', label : t('Task'),  display: true, type: 'string', width: 35, getOptions: getServiceTaskCode},   
      //{id:'userId', label : t('Id'),  display: true, type: 'string', width: 5 },
      // {id:'serviceName', label : t('Service'),  display: true, type: 'string', width: 35, 
      //   isEditable: cellEditableBillingDetail},
      // {id:'employeeFullName', label : t('Employee'),  display: true, type: 'string', width: 35, 
      //   getInputAdornment: getInputAdornmentEmployee},
  
      // {id:'startTime', label : t('Start'),  display: true, type: 'datetime', width: 15, isEditable: cellEditableBillingDetail},
      {id:'employeeFullName', label : t('Employee'),  display: true, type: 'string', width: 60, 
        getInputAdornment: getInputAdornmentServiceTaskEmployee}, 
  
      {id:'part', label : t('Part'),  display: true, type: 'numeric', width: 5, },           
    ]);
  
    const refAppendBillingServiceTasks = useRef<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>(null);
    const refUpdateBillingServiceTask = useRef<(index: number,value: Partial<FieldArray<IBilling>> ) => void>(null);
    const refRemoveBillingServiceTask = useRef<(index: number ) => void>(null);

    type EmployeeUsage = 'business' | 'billing-detail-service' | 'billing-packaging-service' | 'billing-service' | 'billing-packaging' | 'fee';
    const [currentEmployeeUsage, setCurrentEmployeeUsage] = useState<EmployeeUsage>('billing-detail-service');
    
const handleClickSelectEmployee = (event: any, employeeUsage: EmployeeUsage) => {
    setCurrentEmployeeUsage(employeeUsage);      
    setOpenEmployeeFilter(true);
}

const handleClickResetEmployee = (event: any, employeeUsage: EmployeeUsage) => {
    
    if(employeeUsage === 'business') {
        (setValue as any)('businessEmployeeId', 0);
        (setValue as any)('businessEmployeeFullName', '');
        (setValue as any)('businessEmployeeManagerFullName', '');
    }  else {
        const billingDetail = getValues().billingDetails.at(watchBillingDetailIndex);

        if(isFalsy(billingDetail)) return;

        if(employeeUsage === 'fee' ) {
        (setValue as any)(`billingDetails.${watchBillingDetailIndex}.employeeId`, 0, {shouldValidate: true});
        (setValue as any)(`billingDetails.${watchBillingDetailIndex}.employeeFullName`, '', {shouldValidate: true});
        } else if(billingDetail.type === 'service') {
        for(var i=0; i<billingDetail.billingServiceTasks.length; i++ ){  
                        
            (setValue as any)(`billingDetails.${watchBillingDetailIndex}.billingServiceTasks.${i}.employeeId`, 0, {shouldValidate: true});
            (setValue as any)(`billingDetails.${watchBillingDetailIndex}.billingServiceTasks.${i}.employeeFullName`, `` , {shouldValidate: true});             
        }            
        } else if(billingDetail.type === 'packaging') {
        for(var k=0; k< billingDetail.billingPackagingDetails.length; k++) {
            const billingPackagingDetail = billingDetail.billingPackagingDetails[k];
            for(var i=0; i< billingPackagingDetail.billingServiceTasks.length; i++) {
                            
            (setValue as any)(`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${k}.billingServiceTasks.${i}.employeeId`, 0, {shouldValidate: true});
            (setValue as any)(`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${k}.billingServiceTasks.${i}.employeeFullName`, ``, {shouldValidate: true} );              
            }
        }
        }
    }
}


const cellAllowedCapacity = (row: IBillingRentalResource, valueCapacity: number) => {
    const {resourceCapacity } = row;
    
    const allowed = valueCapacity>=0 && valueCapacity<=resourceCapacity;
    debouncedResourceCapacity();
    
    return allowed;
    }
    
    const debouncedResourceCapacity = useRef(
    debounce( () => {
    
        // const sumAmount = sum( getValues().tellerOperationModes.map( ({amount}) => amount ) );
        // setTotalAmountMode(sumAmount);
    }, 300)
    ).current;
    
    const cellEditableBillingRentalResource = (row: IBillingRentalResource, cellId: keyof IBillingRentalResource) => { 
        
        //if(row.type === 'article' && cellId === 'quantity') return true;
        // if(row.type === 'article' && cellId === 'articleOption') return true;
    
        return !row.rentalResourceIsCapacityFixed;
    }
    const [headBillingRentalResourceCells, setHeadBillingRentalResourceCells]  = useState<HeadCell<IBillingRentalResource>[]>([]);
    useEffect(() => {
        setHeadBillingRentalResourceCells([   
            {id:'resourceName', label : t('Name'),  display: true, type: 'string', width: 50},   
            {id:'resourceCapacity', label : t("Resource's capacity"),  display: true, type: 'numeric', width: 25, decimalScale: 2},   
            //{id:'userId', label : t('Id'),  display: true, type: 'string', width: 5 },
            // {id:'serviceName', label : t('Service'),  display: true, type: 'string', width: 35, 
            //   isEditable: cellEditableBillingDetail},
            // {id:'employeeFullName', label : t('Employee'),  display: true, type: 'string', width: 35, 
            //   getInputAdornment: getInputAdornmentEmployee},
        
            // {id:'startTime', label : t('Start'),  display: true, type: 'datetime', width: 15, isEditable: cellEditableBillingDetail},
            
        
            {id:'capacity', label : t('Allocated capacity'),  display: true, type: 'numeric', width: 25, 
            isEditable: cellEditableBillingRentalResource, isAllowed: cellAllowedCapacity, decimalScale: 2},           
        ]);
    }, [t,i18n]);
          
          
    const refAppendBillingRentalResources = useRef<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>(null);
    const refUpdateBillingRentalResource = useRef<(index: number,value: Partial<FieldArray<IBilling>> ) => void>(null);
    const refRemoveBillingRentalResource = useRef<(index: number ) => void>(null);
    
    const getArticleOptionBillingPackagingDetailList = (row: IBillingPackagingDetail, cellId: keyof IBillingPackagingDetail, 
    opts: {value: string|number, name: string}[]) => {        
    
    const {articleFilterOption} = row;
    const enumsFilter = (refEnumItems.current ?? []).filter(x => x.parentEnumerationItemCode === articleFilterOption);
    
    return getAsOptions(enumsFilter ,Enum_ARTICLE_OPTION);
    }
    
    const cellEditableBillingPackagingDetail = (row: IBillingPackagingDetail, cellId: keyof IBillingPackagingDetail) => {   
    if(row.type === 'service') return false;   
    return true;
    }
    
    const [headBillingPackagingDetailCells, setHeadBillingPackagingDetailCells]  = useState<HeadCell<IBillingPackagingDetail>[]>([]);
    useEffect(() => {
    setHeadBillingPackagingDetailCells([   
        {id:'productName', label : t('Name'),  display: true, type: 'string', width: 45},   

        //{id:'userId', label : t('Id'),  display: true, type: 'string', width: 5 },
        // {id:'serviceName', label : t('Service'),  display: true, type: 'string', width: 35, 
        //   isEditable: cellEditableBillingDetail},
        // {id:'employeeFullName', label : t('Employee'),  display: true, type: 'string', width: 35, 
        //   getInputAdornment: getInputAdornmentEmployee},
    
        {id:'productOptionName', label : t('Option'),  display: true, type: 'string', width: 35,},
        {id:'quantity', label : t('Quantity'),  display: true, type: 'numeric', decimalScale: 2, width: 10},
        
        {id:'part', label : t('Part'),  display: true, type: 'numeric', decimalScale: 2, width: 10, },           
    ]);
    }, [t,i18n]);
    
    
    
    const refAppendBillingPackagingDetails = useRef<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>(null);
    const refUpdateBillingPackagingDetail = useRef<(index: number,value: Partial<FieldArray<IBilling>> ) => void>(null);
    const refRemoveBillingPackagingDetail = useRef<(index: number ) => void>(null);
    
    
    const [billingPackagingServiceIndex, setBillingPackagingServiceIndex] = useState<number>(-1);
    const [openBillingPackagingService, setOpenBillingPackagingService] = useState<boolean>(false);
    const billingPackagingDetailRowActionIcon = ( row: IBillingPackagingDetail) : ActionIconTableRow<IBilling,IBillingPackagingDetail> => {
        
    const res: ActionIconTableRow<IBilling,IBillingPackagingDetail> = {
        toolTip: 'viewDetails',
        icon: MoreVertIcon,
        hasAction: row.type === 'service' , // ((optionPropertyName1 || '') !== '') || ((optionPropertyName2 || '') !== '') || ((optionPropertyName3 || '') !== ''),
        isActionExecuting: true,
        onRowClickIcon: (event : any,index: number, row: IBillingPackagingDetail) => {
        
        setBillingPackagingServiceIndex(index);    
        setBillingPackagingServiceTaskIndex(0); 
        setOpenBillingPackagingService(true);       
        }
    }
    return res;
    }
    
    
    const [billingPackagingServiceTaskIndex, setBillingPackagingServiceTaskIndex] = useState<number>(-1);
    
    const getInputAdornmentPackagingServiceTaskEmployee = (row: IBillingServiceTask, cellId: keyof IBillingServiceTask)  => ({
    
        toolTip: 'Subject',
        icon: ArrowDropDownCircleIcon,
        //iconDisable: row.resourceId > 0,
        onClickIcon: (event: any, index: number, row: IBillingServiceTask ) => {
        
        setCurrentEmployeeUsage('billing-packaging-service');
        setBillingPackagingServiceTaskIndex(index);
        setOpenEmployeeFilter(true);
        }  
    })
    
    const getPackagingServiceTaskCode = (row: IBillingServiceTask, cellId: keyof IBillingServiceTask, 
        opts: {value: string|number, name: string}[]) => {        
        
        return getAsOptions(refEnumItems.current ?? [],Enum_SERVICE_TASK);
    }
    
    const [headBillingPackagingServiceTaskCells, setHeadBillingPackagingServiceTaskCells]  = useState<HeadCell<IBillingServiceTask>[]>([]);
    useEffect(() => {
        setHeadBillingPackagingServiceTaskCells([   
        {id:'taskCode', label : t('Task'),  display: true, type: 'string', width: 35, getOptions: getServiceTaskCode},   
        
        {id:'employeeFullName', label : t('Employee'),  display: true, type: 'string', width: 60, 
            getInputAdornment: getInputAdornmentPackagingServiceTaskEmployee}, 
    
        {id:'part', label : t('Part'),  display: true, type: 'numeric', width: 5, },           
        ]);
    }, [t,i18n]);
            
          
    const refAppendBillingPackagingServiceTasks = useRef<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>(null);
    const refUpdateBillingPackagingServiceTask = useRef<(index: number,value: Partial<FieldArray<IBilling>> ) => void>(null);
    const refRemoveBillingPackagingServiceTask = useRef<(index: number ) => void>(null);
          
 const handleClickBeneficiaryIsCustomer = (event: any,prodIndex: number, beneficiaryIsCustomer: boolean) => {
     const billingDetail = getValues().billingDetails.at(prodIndex);
     if(isFalsy(billingDetail)) return;
      
     (setValue as any)(`billingDetails.${prodIndex}.beneficiaryIsCustomer`, beneficiaryIsCustomer, {shouldValidate: true});
     //(refUpdateBillingDetail.current??emptyFunc)(prodIndex, {...billingDetail!, beneficiaryIsCustomer }); 
   }
   
   const handleClickPackagingBeneficiaryIsCustomer = (event: any,bilPackServiceIndex: number, beneficiaryIsCustomer: boolean) => {
     const billingDetail = getValues().billingDetails.at(watchBillingDetailIndex);
     if(isFalsy(billingDetail)) return;
 
     const billingPackagingService = billingDetail.billingPackagingDetails.at(bilPackServiceIndex);
     if(isFalsy(billingPackagingService)) return;
 
     (refUpdateBillingPackagingDetail.current??emptyFunc)(bilPackServiceIndex, {...billingPackagingService!, beneficiaryIsCustomer }); 
   }   


   const refEnumItems = useRef<IEnumerationItem[]>();    
     useEffect( () => {   
         refEnumItems.current = enumItems;
       
     }, [enumItems]);
   
    //  const refEnumItems2 = useRef<IEnumerationItem[]>();    
    //  useEffect( () => {   
    //      refEnumItems2.current = enumItems2;
       
    //  }, [enumItems2]);

  const queryClient = useQueryClient();
  
    

   return (
    
            <Box sx={{ mt: 0.25, width: '100%' }}>
                <Grid container rowSpacing={0.5} columnSpacing={0.1}>
                    <Grid item xs={12} component={Paper} sx={{ borderRadius: 2, ml: 0, }} >
                      <Stack flexDirection='column'>
                        <Box flexDirection='row' sx={{ mt: 0.25, width: '100%', display: 'flex', alignItems: 'center', gap: 4 }} > 
                          <Typography variant="h6" id="tableTitle" color="primary" noWrap 
                                sx={{...typographyGroupBoxStyling}}>
                            {`... ${(watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length)?getValues().billingDetails[watchBillingDetailIndex].productName: ''}  ...`}
                          </Typography> 
                          {(getValues().currentBillingDetailIndex >= 0 && getValues().currentBillingDetailIndex < getValues().billingDetails.length) && <Button
                            variant="outlined"
                            component="button"
                            //variant="body2"
                            onClick={handleLinkClickBillingDetailInfo}
                            sx={{ ml: 1 }}
                          >
                            {t('More infos')}
                          </Button> }  
                          { (openBillingDetailInfo && watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length) &&
                            <FormDialog open={openBillingDetailInfo} maxWidth='md'
                              okText='' cancelText='' title={t('Informations on billing item')} onCancel={()=> {}} 
                              onClose={()=> {setOpenBillingDetailInfo(false);}} onOk={()=> {setOpenBillingDetailInfo(false);}}  >
                              <Stack flexDirection='column'>
                                <Box sx={{ mt: 1, width: '100%' }} key={`details designation ${watchBillingDetailIndex} ${getValues().billingDetails[watchBillingDetailIndex].designation} `}  >
                                  <Controller                   
                                      key={`designation - ${getValues().billingDetails[watchBillingDetailIndex].designation} :::`}                  
                                      render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                      label={t('Designation')} inputProps={ {readOnly: false }}
                                          />}
                                      name={`billingDetails.${watchBillingDetailIndex}.designation`}    
                                      control={control}
                                  />
                                </Box>
                                <Box sx={{ mt: 1, width: '100%' }} key={`details description ${watchBillingDetailIndex} ${getValues().billingDetails[watchBillingDetailIndex].description} `}  >
                                  <Controller                   
                                      key={`description - ${getValues().billingDetails[watchBillingDetailIndex].description} ::`}                  
                                      render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                      label={t('Description')} inputProps={ {readOnly: false }}
                                          />}
                                      name={`billingDetails.${watchBillingDetailIndex}.description`}    
                                      control={control}
                                  />
                                </Box>
                                <Box sx={{ mt: 1, width: '100%' }} key={`details infos ${watchBillingDetailIndex} ${getValues().billingDetails[watchBillingDetailIndex].designation} `}  >
                                  <ArrayFieldTableEx<IBilling,IBillingDetailInfo,'id'> 
                                    mainObject={getValues()} fieldKey='id' 
                                    headCells={headBillingDetailInfoCells} rowsPathName={`billingDetails.${watchBillingDetailIndex}.billingDetailInfos`}
                                    title={t('Informations')} rowActionIcon={billingDetailInfoRowActionIcon}  
                                    //onRowSelected={handleBillingDetailSelected}
                                    //onRowDoubleClick={handleBillingDetailRowDoubleClick}
                                                        
                                    refAppend={refAppendBillingDetailInfos as MutableRefObject<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>}
                                    refUpdate={refUpdateBillingDetailInfo as MutableRefObject<(index: number,value: Partial<FieldArray<IBilling>>) => void>}
                                    refRemove={refRemoveBillingDetailInfo as MutableRefObject<(index: number) => void>}

                                    //stateSelected={[selectedRoleEntities, setSelectedRoleEntities]}
                                    //displayMore={undefined}
                                    toolbarActions={                                
                                      [
                                        { toolTip: `${t('Add')}...`, onClickIcon: handleAddBillingDetailInfos ,icon: AddCircleIcon }, 
                                      ]
                                    } 
                                    canCheckRow={false} //canFilterColumn={false} //canDisplayColumnHeader={false}
                                  />
                                </Box>                                
                              </Stack>
                            </FormDialog>
                          }                                                   
                        </Box>
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && ['article','consumption', 'packaging'].includes(getValues().billingDetails[watchBillingDetailIndex].type) ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info product ${watchBillingDetailIndex} `}  >
                            <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.productOptionId`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(37% - 8px)'}} id="productOptionId"
                                      key={`${getValues().billingDetails[watchBillingDetailIndex].productOptionId} productOptionId`}
                                      label={`${t('Product')} : ${t('Option')}`} inputProps={ {readOnly: true}} >
                                      { (getValues().billingDetails[watchBillingDetailIndex].productOptions || []).map( 
                                        (x,idx) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />
                              { getValues().billingDetails[watchBillingDetailIndex].type === 'consumption' && <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.consumptionOption`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(38% - 8px)'}} id="consumptionOption"
                                      key={getValues().billingDetails[watchBillingDetailIndex].consumptionOption}
                                      label={t('Option')} inputProps={ {readOnly: false}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_CONSUMPTION_OPTION && 
                                         e.parentEnumerationItemCode === getValues().billingDetails[watchBillingDetailIndex].consumptionOptionClass ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              /> }
                              { getValues().billingDetails[watchBillingDetailIndex].type === 'article' && <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.articleOption`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(38% - 8px)'}} id="articleOption"
                                      key={getValues().billingDetails[watchBillingDetailIndex].articleOption}
                                      label={t('Option')} inputProps={ {readOnly: false}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_ARTICLE_OPTION && 
                                         e.parentEnumerationItemCode === getValues().billingDetails[watchBillingDetailIndex].articleFilterOption ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              /> }
                              <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                    <NumberFormat    
                                    key={getValues().billingDetails[watchBillingDetailIndex].quantity}
                                      label={t('Unity price')} sx={{width:'calc(25% - 8px)'}} disabled={true}
                                      allowEmptyFormatting={false}
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.unityAmount`}
                                control={control}
                            />
                            
                                                  
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && ['article','consumption', 'packaging'].includes(getValues().billingDetails[watchBillingDetailIndex].type) ) && 
                          <Box sx={{ mt: 1, width: '100%' }}
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
                            key={`info product qty : ${watchBillingDetailIndex} `}  >
                             
                            <IconButton
                                onClick={(event) => handleQuantityIncDec(watchBillingDetailIndex,-1)}
                                sx={{
                                  //position: "absolute",
                                  //top: 10,
                                  //right: 10,
                                }}
                            >
                              <RemoveCircleIcon sx={{ fontSize: "2rem" }} color="secondary" />
                            </IconButton>  
                            <Controller
                              render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                return (
                                  <NumberFormat    
                                  key={getValues().billingDetails[watchBillingDetailIndex].quantity}
                                    //label={t('Quantity')} 
                                    label={<span>
                                      {t('Quantity')}
                                      { <Link href="#" onClick={(event) => handleQuantityIncDec(watchBillingDetailIndex,-1)}
                                          sx={{ cursor: 'pointer', textDecoration: 'none', color: 'blue', px: 1, fontSize: '20px', fontWeight: 'bold'}} >
                                          -
                                        </Link> }
                                        { <Link href="#" onClick={(event) => handleQuantityIncDec(watchBillingDetailIndex,1)}
                                          sx={{ cursor: 'pointer', textDecoration: 'none', color: 'blue', px: 1, fontSize: '20px', fontWeight: 'bold' }} >
                                          +
                                        </Link> }
                                    </span>}
                                    sx={{width:'calc(25% - 8px)'}} 
                                    disabled={!['article', 'consumption', 'packaging'].includes(getValues().billingDetails[watchBillingDetailIndex].type)}
                                    allowEmptyFormatting={false}
                                    control={control}    
                                    thousandSeparator={lg.includes('fr')?' ':','}
                                    decimalScale={2}
                                    onValueChange={ (v) => onChange(v.floatValue) }                                    
                                    defaultValue={value}
                                    value={value}
                                    customInput={TextFieldCenter}                            
                                  />
                                );
                              }}
                              name={`billingDetails.${watchBillingDetailIndex}.quantity`}
                              control={control}
                            />
                            <IconButton
                                onClick={(event) => handleQuantityIncDec(watchBillingDetailIndex,+1)}
                                sx={{
                                  //position: "absolute",
                                  //top: 10,
                                  //right: 10,
                                }}
                            >
                              <AddCircleIcon sx={{ fontSize: "2rem" }} color="secondary" />
                            </IconButton>
                          </Box> }


                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          /*&&  !['article','packaging','consumption','rental'].includes(getValues().billingDetails[watchBillingDetailIndex].type)*/ ) && 
                          <Box sx={{ mt: 1, width: '100%' }} 
                              key={`info amnt ${getValues().billingDetails[watchBillingDetailIndex].netAmount} ${getValues().billingDetails[watchBillingDetailIndex].amountDiscountedOrLoaded}`}  >
                            <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                    <NumberFormat    
                                      label={t('Discount')} sx={{width:'calc(20% - 8px)'}} disabled={false}
                                      allowEmptyFormatting={false}
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      isAllowed={ (values: NumberFormatValues) => {
                                        const billingDetail = getValues().billingDetails[watchBillingDetailIndex];
                          
                                        return checkAllowedDiscount(billingDetail, values.floatValue || 0);                    
                                      }}
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.discount`}
                                control={control}
                            />
                            <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                    <NumberFormat    
                                      label={t('Loaded')} sx={{width:'calc(20% - 8px)'}} disabled={false}
                                      allowEmptyFormatting={false}
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      isAllowed={ (values: NumberFormatValues) => {
                                        const billingDetail = getValues().billingDetails[watchBillingDetailIndex];
                          
                                        return checkAllowedLoaded(billingDetail, values.floatValue || 0);                    
                                      }}
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.loaded`}
                                control={control}
                            />
                            <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                    <NumberFormat    
                                      label={t('Updated amount')} sx={{width:'calc(20% - 8px)'}} disabled={true}
                                      allowEmptyFormatting={false}
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      isAllowed={ (values: NumberFormatValues) => {
                                        const billingDetail = getValues().billingDetails[watchBillingDetailIndex];
                          
                                        return checkAllowedDiscountOrLoaded(billingDetail, values.floatValue || 0);                    
                                      }}
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.amountDiscountedOrLoaded`}
                                control={control}
                            />
                            
                            <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.pricePurpose`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(40% - 8px)'}} id="pricePurpose"
                                      label={`${t('Purpose')} - ${t('Price')}`} inputProps={ {readOnly: false}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_PRICE_PURPOSE && 
                                         e.parentEnumerationItemCode === getValues().billingDetails[watchBillingDetailIndex].lineOfBusinessCode ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />
                                                     
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          /*&&  !['article','packaging','consumption','rental'].includes(getValues().billingDetails[watchBillingDetailIndex].type)*/ ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info amnt + ${getValues().billingDetails[watchBillingDetailIndex].netAmount} `}  >
                            <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                    <NumberFormat    
                                      label={t('Net amount')} sx={{width:'calc(20% - 8px)'}} disabled={true}
                                      allowEmptyFormatting={false} 
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.netAmount`}
                                control={control}
                            />
                            <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                    <NumberFormat    
                                      label={t('Tax')} sx={{width:'calc(20% - 8px)'}} disabled={true}
                                      allowEmptyFormatting={false} 
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.tax`}
                                control={control}
                            />
                            <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                    <NumberFormat    
                                      label={t('Amount')} sx={{width:'calc(20% - 8px)'}} disabled={true}
                                      allowEmptyFormatting={false} 
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.amount`}
                                control={control}
                            />
                            
                          </Box> }
                        
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                            && ['service', 'formation', 'exam'].includes(getValues().billingDetails[watchBillingDetailIndex].type) ) 
                          && <Box sx={{ mt: 0.25, width: '100%' }} > 
                          <Typography variant="h6" id="tableTitle" color="primary" noWrap 
                                sx={{...typographyGroupBoxStyling}}>
                            {`${t(('Beneficiary'))} `}
                          </Typography> 
                          <Button>                            
                            <Box sx={{ ...justifyCenter, ml: 1 }}>
                            {getValues().billingDetails[watchBillingDetailIndex].beneficiaryIsCustomer ? t('The beneficiary is customer, click to change'): t('The beneficiary is different from the customer, click to make them identical')}
                              {getValues().billingDetails[watchBillingDetailIndex].beneficiaryIsCustomer?
                                <MdOutlineCancel size={24} onClick={(event) => handleClickBeneficiaryIsCustomer(event,watchBillingDetailIndex,false) } />:
                                <MdOutlineCheckCircle size={24} onClick={(event) => handleClickBeneficiaryIsCustomer(event,watchBillingDetailIndex,true) } />}
                            </Box>
                          </Button>                                                       
                        </Box> }
                        

                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && getValues().billingDetails[watchBillingDetailIndex].type === 'maintenance'  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info pers ${getValues().billingDetails[watchBillingDetailIndex].personId} `}  >
                            <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.maintenanceCategory`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="maintenanceCategory"
                                      label={t('Category')} inputProps={ {readOnly: false}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_MAINTENANCE_CATEGORY && 
                                         e.parentEnumerationItemCode === getValues().billingDetails[watchBillingDetailIndex].maintenanceCategoryClass ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />
                              <Controller                   
                                  key={`lastName ${getValues().billingDetails[watchBillingDetailIndex].maintenanceReference} `}                  
                                  render={({ field }) => <TextField sx={{width:`calc(25% - 8px)`}} {...field} 
                                  label={t('Reference')} inputProps={ {readOnly: false }}
                                      />}
                                  name={`billingDetails.${watchBillingDetailIndex}.maintenanceReference`}    
                                  control={control}
                              />
                            <Controller key={`${getValues().billingDetails[watchBillingDetailIndex].maintenanceStartDate}  -`}  
                                  render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <DateTimePicker label={t('Start date')} key={`${getValues().billingDetails[watchBillingDetailIndex].maintenanceStartDate} dob-st x`}
                                    closeOnSelect={false}  
                                    onChange={onChange}                
                                      //inputFormat={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?'dd/MM':'dd/MM/yyyy'}
                                      value={new Date(value)}
                                      //views={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?['month','day']: ['year', 'month', 'day']}
                                      //disabled={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'}
                                      //format={watchBirthDateType==='day'?'MM/dd':'dd/MM/yyyy'}
                                      //renderInput={(params) => <TextField {...params} sx={{width:'calc(20% - 8px)'}} />}
                                      slotProps={{ textField: { sx: {width:'calc(25% - 8px)'}  }} }
                                      //renderInput={(params) => <TextField {...params}  sx={{width:'calc(25% - 8px)'}} />}
                                    /> )}
                                  name={`billingDetails.${watchBillingDetailIndex}.maintenanceStartDate`}    
                                  control={control}
                                />
                                <Controller key={`${getValues().billingDetails[watchBillingDetailIndex].maintenanceEndDate}  -`}  
                                  render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <DateTimePicker label={t('End date')} key={`${getValues().billingDetails[watchBillingDetailIndex].maintenanceEndDate} dob- ne x`}
                                      onChange={onChange}  closeOnSelect={false}              
                                      //inputFormat={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?'dd/MM':'dd/MM/yyyy'}
                                      value={new Date(value)}
                                      //views={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?['month','day']: ['year', 'month', 'day']}
                                      //disabled={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'}
                                      //format={watchBirthDateType==='day'?'MM/dd':'dd/MM/yyyy'}
                                      //renderInput={(params) => <TextField {...params} sx={{width:'calc(20% - 8px)'}} />}
                                      //renderInput={(params) => <TextField {...params}  sx={{width:'calc(25% - 8px)'}} />}
                                      slotProps={{ textField: { sx: {width:'calc(25% - 8px)'}  }} }
                                    /> )}
                                  name={`billingDetails.${watchBillingDetailIndex}.maintenanceEndDate`}    
                                  control={control}
                                />
                            
                                                     
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && getValues().billingDetails[watchBillingDetailIndex].type === 'maintenance'  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info desc ${getValues().billingDetails[watchBillingDetailIndex].maintenanceDescription} `}  >                            
                              <Controller                   
                                  key={`lastName ${getValues().billingDetails[watchBillingDetailIndex].maintenanceDescription} `}                  
                                  render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                  label={t('Description')} inputProps={ {readOnly: false }}
                                      />}
                                  name={`billingDetails.${watchBillingDetailIndex}.maintenanceDescription`}    
                                  control={control}
                              />                           
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && getValues().billingDetails[watchBillingDetailIndex].type === 'fee'  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info emp ${getValues().billingDetails[watchBillingDetailIndex].employeeId} `}  >                            
                              <Controller                   
                                  key={`lastName ${getValues().billingDetails[watchBillingDetailIndex].employeeId} `}                  
                                  render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                  label={`${t('Employee')} ==> ${t('Fee')}`}
                                  InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                      <InputAdornment position="end">  
                                      { (isFalsy(watchBusinessEmployeeId) ||  watchBusinessEmployeeId<=0) ?
                                          <IconButton color="primary" onClick={(event: any) => handleClickSelectEmployee(event, 'fee')}>
                                            <ArrowDropDownCircleIcon />
                                          </IconButton> : 
                                          <IconButton color="primary" onClick={(event: any) => handleClickResetEmployee(event, 'fee')}>
                                            <RemoveCircleIcon />
                                          </IconButton>
                                        }                                                                                                                                     
                                    </InputAdornment>
                                  ) 
                                }} 
                                      />}
                                  name={`billingDetails.${watchBillingDetailIndex}.employeeFullName`}    
                                  control={control}
                              />                           
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && getValues().billingDetails[watchBillingDetailIndex].type === 'contract'  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`contract ${getValues().billingDetails[watchBillingDetailIndex].contractType} ${getValues().billingDetails[watchBillingDetailIndex].contractScope}`}  >
                            <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.contractType`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="contractType"
                                      label={t('Type')} inputProps={ {readOnly: false}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_CONTRACT_TYPE ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />
                              <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.contractScope`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="contractScope"
                                      label={t('Scope')} inputProps={ {readOnly: false}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_CONTRACT_SCOPE && 
                                         e.parentEnumerationItemCode === getValues().billingDetails[watchBillingDetailIndex].contractScopeClass ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />
                            <Controller key={` ctr ef${getValues().billingDetails[watchBillingDetailIndex].contractEffectiveDate}  -`}  
                                  render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <DateTimePicker label={t('Effective date')} key={`${getValues().billingDetails[watchBillingDetailIndex].contractEffectiveDate} dob- x`}
                                      onChange={onChange}  closeOnSelect={false}            
                                      //inputFormat={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?'dd/MM':'dd/MM/yyyy'}
                                      value={new Date(value)}
                                      //views={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?['month','day']: ['year', 'month', 'day']}
                                      //disabled={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'}
                                      //format={watchBirthDateType==='day'?'MM/dd':'dd/MM/yyyy'}
                                      //renderInput={(params) => <TextField {...params} sx={{width:'calc(20% - 8px)'}} />}
                                      slotProps={{ textField: { sx: {width:'calc(25% - 8px)'}  }} }
                                    /> )}
                                  name={`billingDetails.${watchBillingDetailIndex}.contractEffectiveDate`}    
                                  control={control}
                                />
                                <Controller key={`ctr ex ${getValues().billingDetails[watchBillingDetailIndex].contractExpirationDate}  -`}  
                                  render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <DateTimePicker label={t('Expiration date')} key={`${getValues().billingDetails[watchBillingDetailIndex].contractExpirationDate} dob- x`}
                                      onChange={onChange}  closeOnSelect={false}              
                                      //inputFormat={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?'dd/MM':'dd/MM/yyyy'}
                                      value={new Date(value)}
                                      //views={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?['month','day']: ['year', 'month', 'day']}
                                      //disabled={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'}
                                      //format={watchBirthDateType==='day'?'MM/dd':'dd/MM/yyyy'}
                                      //renderInput={(params) => <TextField {...params} sx={{width:'calc(20% - 8px)'}} />}
                                      //renderInput={(params) => <TextField {...params}  sx={{width:'calc(25% - 8px)'}} />}
                                      slotProps={{ textField: { sx: {width:'calc(25% - 8px)'}  }} }
                                    /> )}
                                  name={`billingDetails.${watchBillingDetailIndex}.contractExpirationDate`}    
                                  control={control}
                                />                   
                        </Box> }

                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && getValues().billingDetails[watchBillingDetailIndex].type === 'contract'  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info ctr dzs ${getValues().billingDetails[watchBillingDetailIndex].contractDescription} `}  >                            
                              <Controller                   
                                  key={`lastName ${getValues().billingDetails[watchBillingDetailIndex].contractDescription} `}                  
                                  render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                  label={t('Description')} inputProps={ {readOnly: false }}
                                      />}
                                  name={`billingDetails.${watchBillingDetailIndex}.contractDescription`}    
                                  control={control}
                              />                           
                        </Box> }

                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && getValues().billingDetails[watchBillingDetailIndex].type === 'rental'  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`rental eff ${getValues().billingDetails[watchBillingDetailIndex].productId} def`}  >
                            <Controller key={`ref ${getValues().billingDetails[watchBillingDetailIndex].rentalEffectiveDate}  -`}  
                                  render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <DateTimePicker label={t('Effective date')} 
                                      //key={`${getValues().billingDetails[watchBillingDetailIndex].rentalEffectiveDate} dob- x`}
                                      onChange={onChange}  
                                      //views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}         
                                      //inputFormat={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?'dd/MM':'dd/MM/yyyy'}
                                      value={new Date(value)}
                                      //views={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?['month','day']: ['year', 'month', 'day']}
                                      //disabled={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'}
                                      //format={watchBirthDateType==='day'?'MM/dd':'dd/MM/yyyy'}
                                      //renderInput={(params) => <TextField {...params} sx={{width:'calc(20% - 8px)'}} />}
                                      //renderInput={(params) => <TextField {...params}  sx={{width:'calc(25% - 8px)'}} />}
                                      slotProps={{ textField: { sx: {width:'calc(25% - 8px)'}  }} }
                                    /> )}
                                  name={`billingDetails.${watchBillingDetailIndex}.rentalEffectiveDate`}    
                                  control={control}
                                />
                                
                            <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                  <NumberFormat    
                                    key={getValues().billingDetails[watchBillingDetailIndex].rentalDuration}
                                      label={t('Duration')} sx={{width:'calc(25% - 8px)'}} disabled={false}
                                      allowEmptyFormatting={false}
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.rentalDuration`}
                                control={control}
                            />    
                            <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.rentalPeriodicity`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="rentalPeriodicity"
                                      label={t('Periodicity')} inputProps={ {readOnly: true}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_RENTAL_PERIODICITY ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />
                              <Controller key={`${getValues().billingDetails[watchBillingDetailIndex].rentalExpirationDate}  -`}  
                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                  <DateTimePicker label={t('Expiration date')} key={`${getValues().billingDetails[watchBillingDetailIndex].rentalExpirationDate} dob- y`}
                                    onChange={onChange} closeOnSelect={false}               
                                    //inputFormat={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?'dd/MM':'dd/MM/yyyy'}
                                    value={new Date(value)}
                                    disabled
                                    //views={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?['month','day']: ['year', 'month', 'day']}
                                    //disabled={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'}
                                    //format={watchBirthDateType==='day'?'MM/dd':'dd/MM/yyyy'}
                                    //renderInput={(params) => <TextField {...params} sx={{width:'calc(20% - 8px)'}} />}
                                    //renderInput={(params) => <TextField {...params}  sx={{width:'calc(25% - 8px)'}} />}
                                    slotProps={{ textField: { sx: {width:'calc(25% - 8px)'}  }} }
                                  /> )}
                                name={`billingDetails.${watchBillingDetailIndex}.rentalExpirationDate`}    
                                control={control}
                              />                   
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && getValues().billingDetails[watchBillingDetailIndex].type === 'rental'  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info rent ref ${getValues().billingDetails[watchBillingDetailIndex].rentalReference} `}  >                            
                              <Controller                   
                                  key={`rentalReference ${getValues().billingDetails[watchBillingDetailIndex].rentalReference} `}                  
                                  render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                  label={t('Reference')} inputProps={ {readOnly: false }}
                                      />}
                                  name={`billingDetails.${watchBillingDetailIndex}.rentalReference`}    
                                  control={control}
                              />                           
                        </Box> }

                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                          && ['service', 'formation', 'exam'].includes(getValues().billingDetails[watchBillingDetailIndex].type) && !getValues().billingDetails[watchBillingDetailIndex].beneficiaryIsCustomer  ) && 
                          <Box sx={{ mt: 1, width: '100%' }} key={`info ben ${getValues().billingDetails[watchBillingDetailIndex].personId} ${getValues().billingDetails[watchBillingDetailIndex].birthDateType}`}  >
                            <Controller   
                              key={`personId ${getValues().billingDetails[watchBillingDetailIndex].personId} ${getValues().billingDetails[watchBillingDetailIndex].studentId}`}                               
                              render={({ field }) => <TextField sx={{width:`calc(15% - 8px)`}} {...field} 
                                label={t('Person Id')} inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }
                                InputProps={{
                                  readOnly: true,
                                  endAdornment: (
                                    <InputAdornment position="end">  
                                    { getValues().billingDetails[watchBillingDetailIndex].personId <= 0 ?
                                        <IconButton color="primary" onClick={(event: any) => handleClickOpenPerson(event, 
                                              getValues().billingDetails[watchBillingDetailIndex].type==='service'? `billing-detail-service`: 
                                              getValues().billingDetails[watchBillingDetailIndex].type==='formation'? `billing-detail-formation` : `billing-detail-exam`)}>
                                          <ArrowDropDownCircleIcon />
                                        </IconButton> : 
                                        <IconButton color="primary" onClick={(event: any) => handleClickRemovePerson(event, 
                                              getValues().billingDetails[watchBillingDetailIndex].type==='service'? `billing-detail-service`: 
                                              getValues().billingDetails[watchBillingDetailIndex].type==='formation'? `billing-detail-formation` : `billing-detail-exam`)}>
                                          <RemoveCircleIcon />
                                        </IconButton>
                                      }                                                                                                                                     
                                  </InputAdornment>
                                ) 
                              }}  />}
                              
                              name={ getValues().billingDetails[watchBillingDetailIndex].type==='service'? 
                                      `billingDetails.${watchBillingDetailIndex}.personId` : 
                                      getValues().billingDetails[watchBillingDetailIndex].type==='formation'?  
                                      `billingDetails.${watchBillingDetailIndex}.studentId` : `billingDetails.${watchBillingDetailIndex}.patientId` }                              
                              control={control}
                            />
                            <Controller                     
                                  key={`firstName ${getValues().billingDetails[watchBillingDetailIndex].firstName} `}                
                                  render={({ field }) => <TextField sx={{width:`calc(30% - 8px)`}} {...field} 
                                  label={lg.startsWith('fr')?t('Last name'):t('First name')} inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].personId>0) }}
                                  InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                      <InputAdornment position="end">  
                                      { getValues().billingDetails[watchBillingDetailIndex].personId <= 0 ?
                                          <IconButton color="primary" onClick={(event: any) => handleClickOpenPersonCopy(event, 'billing-detail-service')}>
                                            <CopyAllIcon />
                                          </IconButton> : 
                                          null
                                        }                                                                                                                                     
                                    </InputAdornment>
                                  ) 
                                }}    
                                      />}
                                  name={`billingDetails.${watchBillingDetailIndex}.${lg.startsWith('fr')?'lastName':'firstName'}`}
                                  control={control}
                              /> 
                              <Controller                   
                                  key={`lastName ${getValues().billingDetails[watchBillingDetailIndex].lastName} `}                  
                                  render={({ field }) => <TextField sx={{width:`calc(25% - 8px)`}} {...field} 
                                  label={lg.startsWith('fr')?t('First name'):t('Last name')} inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].personId>0) }}
                                      />}
                                  name={`billingDetails.${watchBillingDetailIndex}.${lg.startsWith('fr')?'firstName':'lastName'}`}    
                                  control={control}
                              />
                              <Controller                           
                                render={ ({field: {onChange, value}}) => (
                                  <TextField select onChange={onChange} value={value} sx={{width:'calc(12% - 8px)'}} id="civility"
                                    label={t('Date type')} inputProps={ {readOnly: false}} focused >
                                    {getBirthDateType().map( 
                                      (x,idx) => <MenuItem key={x.value} value={x.value}>{x.name}</MenuItem> )
                                    }
                                  </TextField>
                                )}
                                name={`billingDetails.${watchBillingDetailIndex}.birthDateType`}    
                                control={control}
                              /> 
                              <Controller key={`${getValues().billingDetails[watchBillingDetailIndex].birthDateType} dob -`}  
                                  render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <DatePicker label={t('Birth date')} key={`${getValues().billingDetails[watchBillingDetailIndex].birthDateType} dob- x`}
                                      onChange={onChange}                
                                      format={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?'dd/MM':'dd/MM/yyyy'}
                                      value={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'?null:new Date(value)}
                                      views={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='day'?['month','day']: ['year', 'month', 'day']}
                                      disabled={getValues().billingDetails[watchBillingDetailIndex].birthDateType==='none'}
                                      //format={watchBirthDateType==='day'?'MM/dd':'dd/MM/yyyy'}
                                      //renderInput={(params) => <TextField {...params} sx={{width:'calc(20% - 8px)'}} />}
                                      slotProps={{ textField: { sx: {width:'calc(18% - 8px)'}  }} }
                                    /> )}
                                  name={`billingDetails.${watchBillingDetailIndex}.birthDate`}    
                                  control={control}
                                />                           
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length 
                            && ['service', 'packaging', 'exam'].includes(getValues().billingDetails[watchBillingDetailIndex].type) && !getValues().billingDetails[watchBillingDetailIndex].beneficiaryIsCustomer ) && 
                        <Box sx={{ mt: 1, width: '100%' }} key={` contact - ${getValues().billingDetails[watchBillingDetailIndex].personId} `}> 
                          <Controller          
                              key={`portable1 ${getValues().billingDetails[watchBillingDetailIndex].portable1} `}                           
                              render={({ field }) => <TextField sx={{width:`calc(25% - 8px)`}} {...field} 
                              label={`${t('Portable')} 1`} inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].personId>0) }}
                                  />}
                              name={`billingDetails.${watchBillingDetailIndex}.portable1`}                              
                                                      
                              control={control}
                          />
                          <Controller             
                              key={`portable2 ${getValues().billingDetails[watchBillingDetailIndex].portable2} `}                        
                              render={({ field }) => <TextField sx={{width:`calc(25% - 8px)`}} {...field} 
                              label={`${t('Portable')} 2`} inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].personId>0) }}
                                  />}
                              name={`billingDetails.${watchBillingDetailIndex}.portable2`}                              
                                                        
                              control={control}
                          />
                          <Controller               
                              key={`email1 ${getValues().billingDetails[watchBillingDetailIndex].email1} `}                      
                              render={({ field }) => <TextField sx={{width:`calc(50% - 8px)`}} {...field} 
                              label={`${t('Email')} 1`} inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].personId>0) }}
                                  />}
                              name={`billingDetails.${watchBillingDetailIndex}.email1`}                              
                                                       
                              control={control}
                          />                                                                                                      
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length && getValues().billingDetails[watchBillingDetailIndex].type === 'service' ) 
                          &&<Box sx={{ mt: 0.25, width: '100%' }} key={`billing service task ${watchBillingDetailIndex} - ${getValues().billingDetails[watchBillingDetailIndex].billingServiceTasks.map(x => x.employeeFullName).join('-')}`}  >
                              <ArrayFieldTableEx<IBilling,IBillingServiceTask,'id'> 
                                mainObject={getValues()} fieldKey='id' key={`billing service ${watchBillingDetailIndex} - task key`}
                                headCells={headBillingServiceTaskCells} rowsPathName={`billingDetails.${watchBillingDetailIndex}.billingServiceTasks`} 
                                title={t('Tasks of service')} //rowActionIcon={billingServiceTaskRowActionIcon}  
                                //onRowSelected={handleBillingDetailSelected}
                                                    
                                refAppend={refAppendBillingServiceTasks as MutableRefObject<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>}
                                refUpdate={refUpdateBillingServiceTask as MutableRefObject<(index: number,value: Partial<FieldArray<IBilling>>) => void>}
                                refRemove={refRemoveBillingServiceTask as MutableRefObject<(index: number) => void>}

                                //stateSelected={[selectedRoleEntities, setSelectedRoleEntities]}
                                //displayMore={undefined}
                                toolbarActions={[
                                ]}
                                canCheckRow={false} //canFilterColumn={false} //canDisplayColumnHeader={false}
                            />
                        </Box>}
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length && getValues().billingDetails[watchBillingDetailIndex].type === 'exam' ) 
                          &&<Box sx={{ mt: 0.25, width: '100%' }} key={`billing exam doc ${watchBillingDetailIndex} - `}  >
                            <Controller key={`doctor  ${getValues().billingDetails[watchBillingDetailIndex].doctorId} `}                        
                              render={({ field }) => <TextField sx={{width:`calc(40% - 8px)`}} {...field} 
                              label={`${t('Doctor')} `} inputProps={ {readOnly: true }} />}
                              name={`billingDetails.${watchBillingDetailIndex}.doctor.fullName`}
                              control={control}
                              />
                            <Controller key={`doctor notes  ${getValues().billingDetails[watchBillingDetailIndex].doctorId} `}                        
                              render={({ field }) => <TextField sx={{width:`calc(60% - 8px)`}} {...field} 
                              label={`${t('Notes')} `} inputProps={ {readOnly: false }} />}
                              name={`billingDetails.${watchBillingDetailIndex}.doctorNotes`}
                              control={control}
                              />
                        </Box>}
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length && getValues().billingDetails[watchBillingDetailIndex].type === 'exam' ) 
                          &&<Box sx={{ mt: 0.25, width: '100%' }} key={`billing exam insur ${watchBillingDetailIndex} - `}  >
                            <FormControlLabel sx={{width:'calc(25% - 8px)'}} label={`${t('Insured ?')}`}
                                control={<Controller
                                              name={`billingDetails.${watchBillingDetailIndex}.useInsurance`} control={control}
                                              render={({field: {value, onChange,...props} }) => <Checkbox {...props} checked={value} onChange={onChange} />}                        
                                          />} />
                            <Controller 
                              name={`billingDetails.${watchBillingDetailIndex}.insuranceUsed`}
                              control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(35% - 8px)'}} id="insuranceUsed"
                                      label={t('Insurance')} inputProps={ {readOnly: false}} >
                                      {enumItems && enumItems.filter( e => e.enumerationCode === Enum_INSURANCE ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />
                              <FormControlLabel sx={{width:'calc(25% - 8px)'}} label={`${t('Main insured ?')}`}
                                control={<Controller
                                    name={`billingDetails.${watchBillingDetailIndex}.isMainInsured`} control={control}
                                    render={({field: {value, onChange,...props} }) => <Checkbox {...props} checked={value} onChange={onChange} />}                        
                                />} />
                              <Controller
                                render={({ field: {onChange, onBlur, name, value, ref} }) => {
                                  return (
                                  <NumberFormat    
                                    key={getValues().billingDetails[watchBillingDetailIndex].rentalDuration}
                                      label={`${t('Insurance')} %`} sx={{width:'calc(15% - 8px)'}} disabled={false}
                                      allowEmptyFormatting={false}
                                      control={control}    
                                      thousandSeparator={lg.includes('fr')?' ':','}
                                      decimalScale={2}
                                      onValueChange={ (v) => onChange(v.floatValue) }
                                      defaultValue={value}
                                      value={value}
                                      customInput={TextFieldRight}                            
                                    />
                                  );
                                }}
                                name={`billingDetails.${watchBillingDetailIndex}.insuranceCoveragePercentage`}
                                control={control}
                            />    
                        </Box>}
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length && getValues().billingDetails[watchBillingDetailIndex].type === 'exam' ) 
                          &&<Box sx={{ mt: 0.25, width: '100%' }} key={`billing exam result ${watchBillingDetailIndex} - `}  >
                            <Controller key={`doctor notes  ${getValues().billingDetails[watchBillingDetailIndex].doctorId} `}                        
                              render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                              label={`${t('Exam result')} `} multiline rows={2} inputProps={ {readOnly: false }} />}
                              name={`billingDetails.${watchBillingDetailIndex}.examResult`}
                              control={control}
                              />
                        </Box>}
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length  && getValues().billingDetails[watchBillingDetailIndex].type === 'packaging' ) &&<Box key={`packaging ${watchBillingDetailIndex} - key`} sx={{ mt: 0.25, width: '100%' }} >
                            <ArrayFieldTableEx<IBilling,IBillingPackagingDetail,'id'> 
                              mainObject={getValues()} fieldKey='id' 
                              headCells={headBillingPackagingDetailCells} rowsPathName={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails`} 
                              title={t('Service(s) or artcle(s) for packaging')} rowActionIcon={billingPackagingDetailRowActionIcon}  
                              //onRowSelected={handleBillingDetailSelected}
                                                  
                              refAppend={refAppendBillingPackagingDetails as MutableRefObject<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>}
                              refUpdate={refUpdateBillingPackagingDetail as MutableRefObject<(index: number,value: Partial<FieldArray<IBilling>>) => void>}
                              refRemove={refRemoveBillingPackagingDetail as MutableRefObject<(index: number) => void>}

                              //stateSelected={[selectedRoleEntities, setSelectedRoleEntities]}
                              //displayMore={undefined}
                              toolbarActions={[
                              ]}
                              canCheckRow={false} //canFilterColumn={false} //canDisplayColumnHeader={false}
                          />
                        </Box>}
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length && ['service', 'packaging'].includes(getValues().billingDetails[watchBillingDetailIndex].type) ) && 
                        <Box display='flex' flexDirection='row' alignContent='space-around' justifyContent='center' sx={{ mt: 1.5, width: '100%' }} > 
                          <Button variant="outlined" onClick={(event) => handleClickSelectEmployee(event, 'billing-service')} sx={{mb:2, ml: 1 }}>
                             {t('Select employee who did the tasks')} ...                             
                          </Button>    
                          <Button variant="outlined" onClick={(event) => handleClickResetEmployee(event, 'billing-service')} sx={{mb:2, ml: 1 }}>
                             {t('Reset all')}                              
                          </Button>                                                   
                        </Box> }
                        { (watchBillingDetailIndex >= 0 && watchBillingDetailIndex < getValues().billingDetails.length && getValues().billingDetails[watchBillingDetailIndex].type === 'rental' ) 
                          &&<Box key={`billing rental ${watchBillingDetailIndex} - ${getValues().billingDetails[watchBillingDetailIndex].billingRentalResources.map(x => x.resourceName).join('-')}`} sx={{ mt: 0.25, width: '100%' }} >
                              <ArrayFieldTableEx<IBilling,IBillingRentalResource,'id'> 
                                mainObject={getValues()} fieldKey='id' key={`billing rental ${watchBillingDetailIndex} - resource key`}
                                headCells={headBillingRentalResourceCells} rowsPathName={`billingDetails.${watchBillingDetailIndex}.billingRentalResources`} 
                                title={t('Tasks of service')} //rowActionIcon={billingServiceTaskRowActionIcon}  
                                //onRowSelected={handleBillingDetailSelected}
                                                    
                                refAppend={refAppendBillingRentalResources as MutableRefObject<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>}
                                refUpdate={refUpdateBillingRentalResource as MutableRefObject<(index: number,value: Partial<FieldArray<IBilling>>) => void>}
                                refRemove={refRemoveBillingRentalResource as MutableRefObject<(index: number) => void>}

                                //stateSelected={[selectedRoleEntities, setSelectedRoleEntities]}
                                //displayMore={undefined}
                                toolbarActions={[
                                ]}
                                canCheckRow={false} //canFilterColumn={false} //canDisplayColumnHeader={false}
                            />
                        </Box>}
                        { ((billingPackagingServiceIndex >= 0) && openBillingPackagingService) && <FormDialog open={openBillingPackagingService} maxWidth='sm'
                              okText='' cancelText='' title={t('Employee')} onCancel={()=> {}} 
                              onClose={()=> {setOpenBillingPackagingService(false);}} onOk={()=> {setOpenBillingPackagingService(false);}}  >
                                  <Box sx={{ mt: 0.25, width: '100%' }} > 
                                    <Typography variant="h6" id="tableTitle" color="primary" noWrap 
                                          sx={{...typographyGroupBoxStyling}}>
                                      {`${t(('Beneficiary'))} `}
                                    </Typography> 
                                    <Button>                            
                                      <Box sx={{ ...justifyCenter, ml: 1 }}>
                                      {getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].beneficiaryIsCustomer ? t('The beneficiary is customer, click to change'): t('The beneficiary is different from the customer, click to make them identical')}
                                        {getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].beneficiaryIsCustomer?
                                          <MdOutlineCancel size={24} onClick={(event) => handleClickPackagingBeneficiaryIsCustomer(event,billingPackagingServiceIndex,false) } />:
                                          <MdOutlineCheckCircle size={24} onClick={(event) => handleClickPackagingBeneficiaryIsCustomer(event,billingPackagingServiceIndex,true) } />}
                                      </Box>
                                    </Button>                                                      
                                  </Box>
                                  {!getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].beneficiaryIsCustomer &&
                                  <Box sx={{ mt: 1, width: '100%' }} key={` info pack ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId} `}>
                                    <Controller                  
                                        key={`pack personId ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId} `}                   
                                        render={({ field }) => <TextField sx={{width:`calc(20% - 8px)`}} {...field} 
                                          label={t('Person Id')} inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }
                                          InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                              <InputAdornment position="end">  
                                              { getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId <= 0 ?
                                                  <IconButton color="primary" onClick={(event: any) => handleClickOpenPerson(event, 'billing-packaging-service')}>
                                                    <ArrowDropDownCircleIcon />
                                                  </IconButton> : 
                                                  <IconButton color="primary" onClick={(event: any) => handleClickRemovePerson(event, 'billing-packaging-service')}>
                                                    <RemoveCircleIcon />
                                                  </IconButton>
                                                }                                                                                                                                     
                                            </InputAdornment>
                                          ) 
                                        }}  />}
                                        
                                        name={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${billingPackagingServiceIndex}.personId`}                              
                                        control={control}
                                    />
                                    <Controller                                     
                                      key={`pack firstName ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].firstName} `}
                                      render={({ field }) => <TextField sx={{width:`calc(40% - 8px)`}} {...field} 
                                      label={lg.startsWith('fr')?t('Last name'):t('First name')} 
                                      inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId>0) }}
                                      InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                          <InputAdornment position="end">  
                                          { getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId <= 0 ?
                                              <IconButton color="primary" onClick={(event: any) => handleClickOpenPersonCopy(event, 'billing-packaging-service')}>
                                                <CopyAllIcon />
                                              </IconButton> : 
                                              null
                                            }                                                                                                                                     
                                        </InputAdornment>
                                      ) 
                                    }} />}
                                      name={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${billingPackagingServiceIndex}.${lg.startsWith('fr')?'lastName':'firstName'}`}
                                      control={control}
                                    />
                                    <Controller              
                                        key={`pack lastName ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].lastName} `}                       
                                        render={({ field }) => <TextField sx={{width:`calc(40% - 8px)`}} {...field} 
                                        label={lg.startsWith('fr')?t('First name'):t('Last name')} 
                                        inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId>0) }}
                                            />}
                                        name={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${billingPackagingServiceIndex}.${lg.startsWith('fr')?'firstName':'lastName'}`}    
                                        control={control}
                                    />                                      
                                  </Box> }
                                  {!getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].beneficiaryIsCustomer &&
                                  <Box sx={{ mt: 1, width: '100%' }} key={` contact pack - ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId} `} > 
                                    <Controller                                     
                                        key={`pack portable1 ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].portable1} `}
                                        render={({ field }) => <TextField sx={{width:`calc(25% - 8px)`}} {...field} 
                                        label={`${t('Portable')} 1`} 
                                        inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId>0) }}
                                            />}
                                        name={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${billingPackagingServiceIndex}.portable1`}                              
                                                                     
                                        control={control}
                                    />
                                    <Controller                           
                                        key={`pack portable2 ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].portable2} `}          
                                        render={({ field }) => <TextField sx={{width:`calc(25% - 8px)`}} {...field} 
                                        label={`${t('Portable')} 2`} 
                                        inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId>0) }}
                                            />}
                                        name={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${billingPackagingServiceIndex}.portable2`}                              
                                                                     
                                        control={control}
                                    />
                                    <Controller                                     
                                        key={`pack email1 ${getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].email1} `}
                                        render={({ field }) => <TextField sx={{width:`calc(50% - 8px)`}} {...field} 
                                        label={`${t('Email')} 1`} 
                                        inputProps={ {readOnly: (getValues().billingDetails[watchBillingDetailIndex].billingPackagingDetails[billingPackagingServiceIndex].personId>0) }}
                                            />}
                                        name={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${billingPackagingServiceIndex}.email1`}                              
                                                                     
                                        control={control}
                                    />                                                                                                                          
                                  </Box> }

                                  <Box key={`${'packaging'} - key`} sx={{ mt: 0.25, width: '100%' }} >
                                    <ArrayFieldTableEx<IBilling,IBillingServiceTask,'id'> 
                                      mainObject={getValues()} fieldKey='id' 
                                      headCells={headBillingPackagingServiceTaskCells} rowsPathName={`billingDetails.${watchBillingDetailIndex}.billingPackagingDetails.${billingPackagingServiceIndex}.billingServiceTasks`} 
                                      title={t('Tasks of service')} //rowActionIcon={billingPackagingDetailRowActionIcon}  
                                      //onRowSelected={handleBillingDetailSelected}
                                                          
                                      refAppend={refAppendBillingPackagingServiceTasks as MutableRefObject<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>}
                                      refUpdate={refUpdateBillingPackagingServiceTask as MutableRefObject<(index: number,value: Partial<FieldArray<IBilling>>) => void>}
                                      refRemove={refRemoveBillingPackagingServiceTask as MutableRefObject<(index: number) => void>}
        
                                      //stateSelected={[selectedRoleEntities, setSelectedRoleEntities]}
                                      //displayMore={undefined}
                                      toolbarActions={[
                                      ]}
                                      canCheckRow={false} //canFilterColumn={false} //canDisplayColumnHeader={false}
                                  />
                                </Box>
                          </FormDialog> }
                          { displayEnumerationItemDialog && <DialogEnumerationItemForm 
                              {...{open: displayEnumerationItemDialog, 
                                    title: '', 
                                    enumerationItem, hideEnumerationItemDialog, saveEnumerationItem,
                                    afterSave: async () => {await refetchEnumerationItems()}}} 
                              />
                          }            
                           
                          
                      </Stack>  
                    </Grid>                   
                </Grid>
            </Box>        
  )
}

